import { render, staticRenderFns } from "./Respiration.vue?vue&type=template&id=b1946a1e&"
import script from "./Respiration.vue?vue&type=script&lang=js&"
export * from "./Respiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports